import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = authed
  const check = useCallback(async () => {
    const { data, status } = await api.get("/auth/me", { validateStatus: () => true });
    if (status === 200) setUser(data);
    else setUser(false);
  }, []);
  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const response = await api.post("/auth/login", { email, password });
    const d = response.data;
    if (response.status !== 200 || (!d?.id && !d?.mfa_required && !d?.mfa_setup_required)) {
      const err = new Error("Invalid credentials");
      err.response = response;
      throw err;
    }
    if (d?.id) setUser(d);
    return d;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* still leave */ }
    setUser(false);
    // Full document reload so a freshly published build is picked up on next sign-in.
    window.location.assign("/login");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refresh: check, applyUser: setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth outside AuthProvider");
  return ctx;
}
